import { MatDialogRef } from "@angular/material/dialog";
import { Terminal } from "xterm";
import { FitAddon } from 'xterm-addon-fit';
import { TerminalComponent } from "../header/dialogs/terminal/terminal.component";

export class TerminalUI {
  terminal: Terminal;
  socket: any;
  fitAddon: FitAddon;
  reqFromPod: boolean = false;

  constructor(socket, public dialogRef: MatDialogRef<TerminalComponent>, container, reqFromPod) {
    this.terminal = new Terminal();
    this.fitAddon = new FitAddon();
    this.terminal.options.theme = {
      background: "#202B33",
      foreground: "#F5F8FA",
      cursor: "#fff",
    }
    this.terminal.options.fontSize = 13;
    this.terminal.options.fontFamily = "monospace";
    this.terminal.options.cursorBlink = true;
    this.terminal.options.cursorStyle = 'block';
    this.terminal.options.scrollback = 10000;
    this.terminal.options.scrollSensitivity = 5;

    this.terminal.resize(120,35);
    this.terminal.loadAddon(this.fitAddon);
    this.fitAddon.activate(this.terminal);
    this.fitAddon.fit
    this.socket = socket;
    this.reqFromPod = reqFromPod;
    this.terminal.onResize((size) => {
      this.socket.emit("resize", size);
    });
  }

  /**
   * Attach event listeners for terminal UI and socket.io client
   */
  startListening() {
    if(this.reqFromPod){
      // this.terminal.onData((data) => this.socket.send(data));

      // this.socket.onmessage = (event) => {
      //   this.write(event.data);
      // };

      // this.socket.onclose = () => {
      //   this.disconnectSocket();
      //   this.dialogRef.close();
      // };

      this.terminal.onData(data => this.sendInput(data));
      this.socket.on("output", data => {
        // When there is data from PTY on server, print that on Terminal.
        this.write(data);
      });
      this.socket.on("disconnected", data => {
        this.disconnectSocket();
        this.dialogRef.close();
      });
    }
    else{
      this.terminal.onData(data => this.sendInput(data));
      this.socket.on("output", data => {
        // When there is data from PTY on server, print that on Terminal.
        this.write(data);
      });
      this.socket.on("disconnected", data => {
        this.disconnectSocket();
        this.dialogRef.close();
      });
    }
  }

  /**
   * Print something to terminal UI.
   */
  write(text) {
    if(text == "User cannot be verified."){
      this.clear();
    }
    this.terminal.write(text);
  }

  /**
   * Utility function to print new line on terminal.
   */
  prompt() {
    this.terminal.write(`\r\n$ `);
  }

  /**
   * Send whatever you type in Terminal UI to PTY process in server.
   * @param {*} input Input to send to server
   */
  sendInput(input) {
    // if(!this.reqFromPod){
    //   this.socket.emit("input", input);
    // }
    this.socket.emit("input", input);
  }

  /**
   *
   * @param {HTMLElement} container HTMLElement where xterm can attach terminal ui instance.
   */
  attachTo(container) {
    this.terminal.open(container);
    this.prompt();
  }

  disconnectSocket(){
    // if(this.reqFromPod){
    //   this.socket.close();
    // }
    // else{
    //   this.socket.disconnect(true);
    // }
    this.socket.disconnect(true);
  }

  clear() {
    this.terminal.clear();
  }

  resize(cols: number, rows: number) {
    this.terminal.resize(Math.round(cols), Math.round(rows));
    this.fitAddon.fit();
  }

  fit(){
    this.fitAddon?.fit();
  }
}
